<div class="container" title="Drop files here or click to upload" appDnd (fileDropped)="onFileDropped($event)">
  <input class="pointer" type="file" accept="{{ accept }}" #fileDropRef id="fileDropRef" [multiple]="multiple"
         (change)="fileBrowseHandler($event.target.files)" />
  <span class="f-12">{{ contentStr }}</span>
</div>

